import clsx from 'clsx'
import HtmlParser from 'components/Assessment/HtmlParser'
import { AssignmentBodyItem, QuestionBodyItem } from 'interfaces/assignments'

interface SectionContainerProps {
  bodyItems: QuestionBodyItem[] | AssignmentBodyItem[]
  readOnly: boolean
}

const SectionContainer = ({ bodyItems, readOnly }: SectionContainerProps) => {
  /**
   * This component will only render the "Section" page of the assignment.
   * A "Section" page is student facing authored content with paragraphs and pictures
   *
   * All the content will be available in one key entirely from the backend called content_html,
   * which will be rendered in a rich text editor for better formatting.
   *
   * Additionally we will also support student / teacher modes if user wants to see how the authored
   * content will look like for the students
   *
   */
  return (
    <>
      {bodyItems.map((item, index) => {
        return (
          <div
            key={item.id || index}
            className='contrast-area'
            style={{ marginTop: 10 }}
          >
            <HtmlParser
              html={item.content_html}
              className={clsx('cms-content-area')}
            />
          </div>
        )
      })}
    </>
  )
}

export default SectionContainer
